import React from "react";
import "../styles/Telemedicine.css";

const TelemedicinePage = () => {
  const [isDarkMode, setDarkMode] = React.useState(false);

  const toggleDarkMode = () => {
    setDarkMode(!isDarkMode);
  };

  const telemedicineApps = [
    {
      name: "CareHub Central",
      description:
        "Care Hub Central streamlines clinic operations, centralizes patient records, tracks wait times, and provides \n patients with an intuitive dashboard summarizing their visits and treatment plans, enhancing both care delivery\n and patient experience.",
      visual: [
        "/img/carehubcentral.png",
        "/img/carehubcentral2.png",
        "/img/carehubcentral3.png",
      ],
      techStack: ["Typescript", "ExpressJS", "PostgreSQL", "Zod", "PrismaOrm"],
      role: "Full Stack Developer + Figma Designer",
      github: "https://github.com/merytpeters/cyc-comm-clinic",
      live: "https://carehubcentral.vercel.app",
      technicalOverview: {
        backend: {
          framework: "ExpressJS / Zod",
          database: "PostgreSQL",
          ORM: "Prisma",
          authentication: "JWT-based authentication",
        },
        frontend: {
          framework: "Typescript",
          stateManagement: "Redux, Zustand",
          UI_Library: "Tailwind CSS",
          componentDesign: "shadcn/ui",
        },
        architecture:
          "The backend is a single codebase but organized into modular APIs\n (patients, providers, appointments, prescriptions, etc.). Each module has its own services, controllers\n and routes, making the system easy to maintain and extendable.",
        dataFlow:
          "User input (React frontend) → API request (Axios) → Express API → Database (Postgres) → API response →\n State update → UI re-render",
        security:
          "Role-based access control, JWT authentication, HTTPS, encrypted user data",
        deployment: "Vercel (frontend) & Render (backend)",
        features: [
          "Centralized patient records for easy access and management",
          "Role-based dashboards for patients, providers, admins, and receptionists",
          "Appointment scheduling and wait-time tracking",
          "Vitals tracking, SOAP notes, and prescription forms",
          "Patients can view their vitals and treatment plans",
          "Admins and receptionists can assign and monitor all activities",
        ],
      },
    },
    {
      name: "MedFinder",
      description:
        "An agent to agent(A2A) bot that tells the location of medical services when prompted",
      techStack: ["FasAPI"],
      role: "Full Stack Developer",
      github:
        "https://github.com/merytpeters/HNG-2025/tree/main/Backend/medFinder",
      live: "https://merytpeters-a5d31.sevalla.app/medfinder/docs",
      technicalOverview: {
        backend: {
          framework: "FastAPI",
          database: "",
          APIs: "https://merytpeters-a5d31.sevalla.app/medfinder/docs",
        },
        frontend: {
          videoUI: "/videos/meddy.mov",
        },
      },
    },
    {
      name: "Health Aid",
      description:
        "Health Aid is a digital health platform designed to help users take control of their health through AI-driven symptom tracking,\n reminders, and interactive health tools.\n This project is currently in development.",
      visual: ["/img/healthaidWeb.png"],
      techStack: ["React/Typescript", "Python", "fastAPI"],
      role: "Backend Developer (Full Stack for New Version)",
      github: "Private Repository",
      live: "https://health-aid-v1-1.vercel.app",
      technicalOverview: {
        backend: {
          framework: "FastAPI (Python)",
          database: "PostgreSQL (planned) / SQLite (currently)",
          ORM: "SQLAlchemy",
          authentication: "JWT-based authentication",
          APIs: "https://health-aid-v1-1.vercel.app/app/dashboard",
          AI_Integration: "Symptom checker powered by APIMEDIC API",
        },
        frontend: {
          framework: "React",
          stateManagement: "Context API",
          UI_Library: "CSS",
          componentDesign: "Reusable modular components",
        },
        architecture:
          "Monolithic with modular API design for future scalability",
        dataFlow: "User input → Flask REST API → Database → Response",
        security:
          "Role-based access control, JWT authentication, HTTPS, encrypted user data",
        deployment:
          "Currently in local development; planned deployment on Vercel (frontend) & Render/AWS (backend)",
        features: [
          "Symptom Tracker with AI-based recommendations",
          "Health Journal for symptom logging",
          "First Aid Guide with real-time health tips",
          "Drug Interaction Checker",
          "Medication Reminder System",
        ],
      },
    },
    {
      name: "ClinicSphere",
      description:
        "ClinicSphere is an Electronic Health Record (EHR) system.\n Currently, only the backend APIs are available.\n It allows healthcare providers to manage patient records, schedule appointments, and bill patients.\n Patients will be able to book appointments, view their medical records, and pay bills once the full system is deployed.",
      visual: [
        "/img/CSmedapiendpoints.png",
        "img/CSDjango.png",
        "img/CSpatientapiendpoints.png",
      ],
      techStack: ["Django", "Sqlite", "React"],
      role: "Full Stack Developer",
      github: "https://github.com/merytpeters/ClinicSphere",
      live: "https://clinicsphere.onrender.com/api/",
      technicalOverview: {
        backend: {
          framework: "Django",
          database: "SQLite",
          authentication: "JWT-based authentication",
          APIs: "RESTful APIs using Django REST Framework (DRF)",
        },
        frontend: {
          framework: "React (planned)",
          stateManagement: "Context API/Redux (TBD)",
          UI_Library: "Tailwind CSS (planned)",
        },
        architecture:
          "Monolithic architecture for now, with plans to modularize",
        dataFlow: "User requests → Django REST API → SQLite DB → Response",
        security:
          "Role-based access control, JWT authentication, HTTPS (planned)",
        deployment:
          "Currently in local development; planned deployment on AWS or DigitalOcean",
        features: [
          "User Authentication & Authorization",
          "Patient & Provider Profile Management",
          "Appointment Scheduling",
          "Billing & Invoicing",
          "Prescription Management",
          "Lab Result Integration",
          "Reporting Tools",
        ],
      },
    },
    {
      name: "Telhealth",
      description:
        "Telhealth is a telemedicine platform that allows patients to book appointments with healthcare providers,\n have video consultations and get prescriptions.\n This project is currently in development.",
      techStack: ["React/Typescript", "Express/Typescript", "MongoDB"],
      role: "Frontend Developer",
      github: "Private Repository",
      live: "Coming soon...",
      technicalOverview: {
        backend: {
          framework: "Express (TypeScript)",
          database: "MongoDB",
          ORM: "Mongoose ODM",
          authentication: "JWT-based authentication",
          APIs: "RESTful APIs for user authentication, appointments, video links, and prescriptions",
          realTime: "Socket.IO for notifications & updates",
          videoIntegration:
            "Google Meet API for secure video consultations (meeting links generated dynamically)",
        },
        frontend: {
          framework: "React (TypeScript)",
          stateManagement: "React Context API",
          UI_Library: "Tailwind CSS for styling",
          componentDesign: "Reusable UI components for modular development",
          videoUI: "Google Meet integration for video consultations",
        },
        architecture:
          "Microservices-inspired, with a modular backend for scalability",
        dataFlow:
          "User books appointment → API generates Google Meet link → Link is stored & sent to patient/provider → UI updates",
        security:
          "JWT authentication, OAuth 2.0 for Google Meet API, and HTTPS enforcement (planned)",
        deployment:
          "Currently in development; planned deployment on Vercel (frontend) & AWS/Render (backend)",
        features: [
          "Appointment scheduling system with provider availability",
          "Google Meet integration for video consultations",
          "Secure messaging between patients and providers",
          "Prescription management and e-prescriptions",
          "Health records storage with role-based access",
        ],
      },
    },
  ];

  return (
    <div className="tele-container">
      <h1>HealthTech Projects</h1>
      <p className="healthtechintro">
        This is my dedicated space for healthtech projects, a collection of
        backend and full stack, impact-driven solutions I've enjoyed <br /> building.
        Each project reflects my passion for technology in healthcare and my
        drive to create tools that make a difference in <br /> patient care and clinic
        operations.
      </p>

      <div className={`Tele ${isDarkMode ? "dark" : "light"}`}>
        <div className="dark-mode-toggle">
          <button
            onClick={toggleDarkMode}
            style={{
              backgroundColor: isDarkMode ? "#B0C4DE" : "#09092d",
              color: isDarkMode ? "#09092d" : "#B0C4DE",
              width: "13%",
            }}
          >
            {isDarkMode ? "Light" : "Dark"}
          </button>
        </div>
        {telemedicineApps.map((app, index) => (
          <div key={index} className="app-card">
            <h2>{app.name}</h2>
            <div className="image-scroll">
              {app.visual?.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`${app.name} visual ${index + 1}`}
                />
              ))}
            </div>
            <p>
              {app.description.split("\n").map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                  <br />
                </span>
              ))}
            </p>
            <h3 className="techstack">
              Tech Stack:{" "}
              {app.techStack.map((tech, index) => (
                <span key={index} className="tech-bubble">
                  {tech}
                </span>
              ))}
            </h3>
            <p>
              My Role: <strong>{app.role}</strong>
            </p>
            <p>
              {app.github === "Private Repository" ? (
                <span>
                  GitHub: <em>Private Repository</em>
                </span>
              ) : (
                <span>
                  GitHub:
                  <a
                    href={
                      Array.isArray(app.github) ? app.github[0] : app.github
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {index === 0
                      ? "See Repository for test logins"
                      : "See Repository"}
                  </a>
                </span>
              )}
            </p>
            <p>
              {app.live === "Coming soon..." ? (
                <span>
                  Live: <em>Coming Soon</em>
                </span>
              ) : (
                <span>
                  Live:{" "}
                  <a href={app.live} target="_blank" rel="noopener noreferrer">
                    Visit Website
                  </a>
                </span>
              )}
            </p>
            <h3>Technical Overview</h3>
            {app.technicalOverview && (
              <ul>
                {app.technicalOverview.backend && (
                  <li>
                    <strong>Backend:</strong>
                    {app.technicalOverview.backend.framework && (
                      <p>
                        Framework: {app.technicalOverview.backend.framework}
                      </p>
                    )}
                    {app.technicalOverview.backend.database && (
                      <p>Database: {app.technicalOverview.backend.database}</p>
                    )}
                    {app.technicalOverview.backend.ORM && (
                      <p>ORM: {app.technicalOverview.backend.ORM}</p>
                    )}
                    {app.technicalOverview.backend.authentication && (
                      <p>
                        Authentication:{" "}
                        {app.technicalOverview.backend.authentication}
                      </p>
                    )}
                    {app.technicalOverview.backend.APIs && (
                      <p>
                        APIs:{" "}
                        {/^https?:\/\//.test(
                          app.technicalOverview.backend.APIs
                        ) ? (
                          <a
                            href={app.technicalOverview.backend.APIs}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {app.technicalOverview.backend.APIs}
                          </a>
                        ) : (
                          app.technicalOverview.backend.APIs
                        )}
                      </p>
                    )}
                    {app.technicalOverview.backend.AI_Integration && (
                      <p>
                        AI Integration:{" "}
                        {app.technicalOverview.backend.AI_Integration}
                      </p>
                    )}
                  </li>
                )}
                <br />
                {app.technicalOverview.frontend && (
                <li>
                  <strong>Frontend:</strong>
                  {app.technicalOverview.frontend.framework && (
                    <p>Framework: {app.technicalOverview.frontend.framework}</p>
                  )}
                  {app.technicalOverview.frontend.stateManagement && (
                    <p>State Management: {app.technicalOverview.frontend.stateManagement}</p>
                  )}
                  {app.technicalOverview.frontend.UI_Library && (
                    <p>UI Library: {app.technicalOverview.frontend.UI_Library}</p>
                  )}
                  {app.technicalOverview.frontend.componentDesign && (
                    <p>Component Design: {app.technicalOverview.frontend.componentDesign}</p>
                  )}
                  {app.technicalOverview.frontend.videoUI && (
                    (() => {
                      const raw = Array.isArray(app.technicalOverview.frontend.videoUI)
                        ? app.technicalOverview.frontend.videoUI[0]
                        : app.technicalOverview.frontend.videoUI;
                      // consider it a media URL if it ends with a common video extension
                      const isMediaUrl =
                        typeof raw === 'string' && /\.(mp4|mov|webm|ogg|m4v)(\?.*)?$/i.test(raw);

                      if (isMediaUrl) {
                        return (
                          <div className="video-ui">
                            <p>Video UI:</p>
                            <video controls width="480" style={{ maxWidth: '100%', height: 'auto' }}>
                              <source src={raw} />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        );
                      }

                      // otherwise render as plain text (allows descriptive text)
                      return <p>Video UI: {raw}</p>;
                    })()
                  )}
                </li>
                )}
                <br />
                {app.technicalOverview?.architecture && (
                  <li>
                    <strong>Architecture:</strong>{" "}
                    {app.technicalOverview.architecture.split('\n').map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                        <br />
                      </span>
                    ))}
                  </li>
                )}

                {app.technicalOverview?.dataFlow && (
                  <li>
                    <strong>Data Flow:</strong> {app.technicalOverview.dataFlow.split('\n').map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                        <br />
                      </span>
                    ))}
                  </li>
                )}

                {app.technicalOverview?.security && (
                  <li>
                    <strong>Security:</strong> {app.technicalOverview.security}
                  </li>
                )}
                <br />
                {app.technicalOverview?.deployment && (
                  <li>
                    <strong>Deployment:</strong>{" "}
                    {app.technicalOverview.deployment}
                  </li>
                )}
                <br />
                {app.technicalOverview?.features?.length > 0 && (
                  <li>
                    <strong>Features:</strong>
                    {app.technicalOverview.features.map((feature, index) => (
                      <p key={index}>{feature}</p>
                    ))}
                  </li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TelemedicinePage;
